import { useQuery } from '@redwoodjs/web';
import { GetLedgerAccountsFragment } from 'types/graphql';

const GET_LEDGER_ACCOUNTS_FRAGMENT = gql`
  query GetLedgerAccountsFragment {
    ledgerAccountFragmentDetails {
      key
      path
      ownBalance
      childBalance
    }
  }
`;

export function useLedgerAccountsFragment() {
  const { data } = useQuery<GetLedgerAccountsFragment>(GET_LEDGER_ACCOUNTS_FRAGMENT);

  return data?.ledgerAccountFragmentDetails ?? [];
}
